import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ResultsFormat, Margins, DateProcessingResult } from '../../../components/groupStepDetails/groupStepDetails.chart';
import { IGroupResultsService } from './groupResults.service';
import { refreshClick } from '../../../common/events';
import { momentFormat } from '../../../common/constants';
import { ComponentDefinition, Dictionary, IValueViewModel, RefreshClickData } from '../../../models';
import { IStoreService } from '../../../services';
import { Store, StoreElement } from '../../../stateManagement';

class GroupResultsStatusStateController implements angular.IComponentController {
    data: ResultsFormat[];
    isLoading: boolean;
    groupGuid: string;
    loadingMessage: string;
    margins: Margins;
    viewModels: Dictionary<IValueViewModel>;

    static $inject = ['$scope', '$stateParams', '$translate', 'groupResultsService', 'storeService'];

    constructor(
        private _$scope: angular.IScope,
        private _$stateParams: angular.ui.IStateParamsService,
        private _$translate: angular.translate.ITranslateService,
        private _groupResultsService: IGroupResultsService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.margins = {
            top: 20,
            bottom: 5,
            left: 150 - 97,
            right: 5 - 1 + 169
        };
        this.groupGuid = this._$stateParams['groupGuid'];
        this._storeService.register(
            store => this.refreshStore(store),
            [StoreElement.ValueViewModels]
        );
        this._$scope.$on(refreshClick, (event, data: RefreshClickData) => {
            this.isLoading = true;
            this._groupResultsService.getResults(this.groupGuid, data.beginDate, data.endDate, data.force)
                .then(d => this.data = d)
                .finally(() => this.isLoading = false);
        });
    }

    messageFormat(d: DateProcessingResult): string {
        if (d.parameters && d.parameters.creationDate) {
            d.parameters.creationDate = moment(d.parameters.creationDate).format(momentFormat);
        }
        let message = `${moment(d.timeStamp).format(momentFormat)}\r\n${this._$translate.instant(d.message, d.parameters)}`;
        if (d.parameters && d.parameters.error) {
            message = `${message}\r\n${d.parameters.error}`;
        }
        return message;
    }

    private refreshStore(store: Store) {
        this.viewModels = store.valueViewModels.dictionary;
    }
}

export const wtGroupResultsStatusState: ComponentDefinition = {
    componentId: 'wtGroupResultsStatusState',
    controller: GroupResultsStatusStateController,
    template: require('./groupResultsStatusState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};